export default __webpack_public_path__ + "assets/ec81700360c20cad483b8db4787c00ab.png";